import type { V2RoundEpisodeRow } from "@softmax/observatory-client/types";
import type { GameAddress } from "@softmax/web-addresses";
import { buildHref } from "@softmax/web-addresses";

export type RoundEpisodeRow = V2RoundEpisodeRow;

export type RoundEpisodePageQuery = {
  roundId: string;
  limit: number;
  cursor?: string;
  completedOnly?: boolean;
};

/** Builds the round episode URL shared by browser and server transports. */
export function roundEpisodesPath({
  roundId,
  limit,
  cursor,
  completedOnly = false,
}: RoundEpisodePageQuery): string {
  const completed = completedOnly ? "&completed_only=true" : "";
  const cursorParam =
    cursor == null ? "" : `&cursor=${encodeURIComponent(cursor)}`;
  return `/v2/rounds/${roundId}/episodes?limit=${limit}${cursorParam}${completed}`;
}

export function roundEpisodeViewingHref({
  episode,
  gameAddress,
}: {
  episode: Pick<RoundEpisodeRow, "id" | "episode_id">;
  gameAddress?: GameAddress | null | undefined;
}): string {
  return episode.episode_id
    ? buildHref({
        name: "episode",
        episodeId: episode.episode_id,
        game: gameAddress,
      })
    : buildHref({
        name: "requestWatch",
        requestId: episode.id,
        game: gameAddress,
      });
}
